import * as React from "react";

export default function DeliveryReturn() {
  return (
    <main className="container mx-auto max-w-3xl px-4 py-10">
      <div 
        className="rounded-xl border bg-white p-6 shadow-sm" 
        style={{ marginTop: "120px" }}
      >
        <h1 className="heading-1 mb-2">Delivery & Return Policy</h1>
        <p className="body-small text-gray-600">Last updated: [December, 2025]</p>

        <div className="mt-6 space-y-4 text-sm leading-6 text-gray-700">
          <p>
            We deliver within the Benelux region using PostNL or a similar courier. 
            Average delivery time is 2–5 business days after payment is received.
          </p>
          <p>
            Edible products can only be returned if they are damaged or incorrect upon arrival. 
            Please report any issues within 14 days of delivery with your order details and photos.
          </p>
          <p>
            Once verified, we will either send a replacement or issue a refund. 
            For questions, contact us at <a href="mailto:info@magomeal.nl" className="underline">info@magomeal.nl</a>.
          </p>
        </div>
      </div>
    </main>
  );
}
